<template>
  <div>
    <v-list class="pa-0 users-select-list"
            :class="$vuetify.breakpoint.name">
    <v-list-item v-for="user in users"
                 :key="user.id"
                 class="pa-0"
                 style="min-height: unset">
      <v-list-item-content class="pa-0">
        <v-list-item-title>{{ user | user }}</v-list-item-title>
        <v-divider/>
      </v-list-item-content>
      <v-list-item-action class="ma-0">
        <v-btn @click="removeUser(user)"
               icon
               :title="$t('actions.delete')">
          <v-icon>mdi-minus-circle-outline</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <user-select-field :show-select-dialog-button="true"
                       :show-add-dialog-button="true"
                       :dense="true"
                       @change="addUser"
                       v-model="userToAdd"
                       class="mb-1 mt-1"
                       :label="$t('actions.add')"/>
    </v-list>
  </div>
</template>

<script>
import UserSelectField from '@/components/inputs/UserSelectField';

export default {
  name: 'MultipleUsersSelect',
  components: { UserSelectField },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  computed: {
    users: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
  },
  data: () => ({
    userToAdd: null,
  }),
  methods: {
    addUser(user) {
      if (!user) {
        return;
      }

      if (this.users.some((userInList => userInList.id === user.id))) {
        this.userToAdd = null;
        return;
      }
      this.users.push(user);
      this.userToAdd = null;
    },

    removeUser(userToRemove) {
      this.users = this.users.filter((user => user.id !== userToRemove.id));
    },
  },
};
</script>

<style>
.xs.users-select-list{
  max-width: unset;
}
.users-select-list{
  max-width: 20em;
}
</style>
